import React, { Component, Fragment } from 'react';
import { formatDateLongMonth, formatDateShortMonth } from '@ami/react/core';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Modal } from '@ami/react/core';
import { LinkButton } from '@ami/react/core';

const Image = ({ imageUrl, alt }) => {
  return imageUrl ? (
    <img
      src={imageUrl}
      className="img-fluid"
      alt={alt}
      style={{ maxWidth: '100px', float: 'left', marginRight: '10px' }}
    />
  ) : (
    <span></span>
  );
};

export default class RecentOrdersComponentShipment extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { showModal: false };
  }

  render() {
    const { shipment } = this.props;
    return (
      <Fragment>
        <div className="row">
          <div className="col-3">
            <LinkButton
              id={shipment.id}
              label={`Qty: ${_.sumBy(shipment.products, 'quantity')}`}
              onClick={() => this.setState({ showModal: true })}
            />
          </div>
          <div className="col-5">
            {formatDateShortMonth(shipment.shipmentDate)}
          </div>
          <div className="col-4">
            <strong>{shipment.status}</strong>
          </div>
        </div>
        <Modal
          size="lg"
          title={`Shipment ${formatDateLongMonth(shipment.shipmentDate)}`}
          okTitle="Close"
          show={this.state.showModal}
          onShowUpdated={() => {}}
          onOk={() => {
            this.setState({ showModal: false });
          }}
          closeOnOk={false}
        >
          <ul className="list-group">
            {shipment.products.map((product, i) => (
              <li key={i} className="shipment-line-item list-group-item">
                <div className="row">
                  <div className="col-12 col-sm-6 text-break-line">
                    <Image imageUrl={product.imageUrl} alt="product" />
                    <div className="line-description">
                      {product.name}
                      <br />
                      {product.details}
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <div className="row">
                      <div className="col-6">
                        <div className="label">Part Number</div>
                        <strong>{product.partNumber}</strong>
                      </div>
                      <div className="col-6">
                        <div className="label">Quantity</div>
                        <strong>{product.quantity}</strong>
                      </div>
                    </div>
                    <div className="row mt-2">
                      {product.serialNumbersEnabled && (
                        <div className="col-6">
                          <div className="label">Serial Numbers</div>
                          {product.serialNumbers.map((sn, idx) => (
                            <Fragment key={idx}>
                              {idx > 0 && <br />}
                              <strong>{sn}</strong>
                            </Fragment>
                          ))}
                        </div>
                      )}
                      {product.serialNumbersEnabled &&
                        product.dealerItemIds.length > 0 && (
                          <div className="col-6">
                            <div className="label">Stock Numbers</div>
                            {product.dealerItemIds.map((dealerItemId, idx) => (
                              <Fragment key={idx}>
                                {idx > 0 && <br />}
                                <strong>{dealerItemId}</strong>
                              </Fragment>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Modal>
      </Fragment>
    );
  }
}
